import { createSyncAction } from '@bimser/core';
import {
	SetSelectedItemsPayloadFactoryFromJS,
	ISetSelectedItemsPayload,
	ISetShowModePayload,
	SetShowModePayloadFactoryFromJS
} from '../../entities';
import * as ActionTypes from '../actionTypes';

export function setSelectedItems(payload: ISetSelectedItemsPayload) {
	return createSyncAction(
		ActionTypes.SET_SELECTED_ITEMS,
		SetSelectedItemsPayloadFactoryFromJS(payload)
	);
}

export function setShowMode(payload: ISetShowModePayload) {
	return createSyncAction(ActionTypes.SET_SHOW_MODE, SetShowModePayloadFactoryFromJS(payload));
}
